<template>
  <div class="gl-offers">
    <vue-progress-bar/>

    <div v-if="success || (errors && errors.length)" class="gl-alert_padding">
      <div v-if="success" class="notification is-success">
        <b>Товар успешно добавлен в вашу <a href="/shop/cart">корзину</a>.</b>
      </div>

      <div v-if="errors && errors.length" class="notification is-danger">
        <div><b>Ошибка</b></div>
        <div v-for="e in errors">{{e.message}}</div>
      </div>
    </div>

    <table class="table">
      <thead>
      <tr>
        <th><abbr title="Размер">Размер</abbr></th>
        <th class="is-hidden-mobile"><abbr title="Цена">Цена</abbr></th>
        <th width="150"></th>
      </tr>
      </thead>
      <tfoot>
      <tr>
        <th colspan="3">
          Выбрано: {{numeral(selectedCount).format('0,0')}} на сумму {{numeral(selectedPrice).format('0.00 $')}}
        </th>
      </tr>
      </tfoot>
      <tbody>
      <tr v-for="(item, index) in innerValue">
        <td>
          <div>{{item.offer.name}}</div>
          <div>{{numeral(item.offer.price).format('0.00 $')}}</div>
        </td>
        <td class="is-hidden-mobile">{{numeral(item.offer.price).format('0.00 $')}}</td>
        <td>
          <div class="field is-grouped gl-increment-block">
            <p class="control">
              <button
                @click="handleIncrement(index, -1)"
                :disabled="item.quantity <= 0"
                class="button is-success" title="Убрать">
                <icon name="minus" scale="1" class="el-icon-fa"></icon>
              </button>
            </p>

            <p class="control is-expanded">
              <input
                v-model.number="innerValue[index].quantity"
                @input="_setQuantity(index, $event.target.value)"
                class="input count"
                placeholder="Количество"/>
            </p>

            <p class="control">
              <button
                @click="handleIncrement(index, 1)"
                class="button is-success" title="Добавить">
                <icon name="plus" scale="1" class="el-icon-fa"></icon>
              </button>
            </p>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <div v-if="selectedCount > 0" class="buttons">
      <button
        @click="handlePutToCart"
        :disabled="loading"
        :class="[{'is-loading': loading}, 'button', 'is-primary']">
        <span class="icon">
          <icon name="check" scale="1" class="el-icon-fa"></icon>
        </span>
        <span>Добавить в корзину</span>
      </button>

      <a v-if="success" href="/shop/cart" class="button is-info">Перейти в корзину</a>

      <button
        @click="handleReset"
        :disabled="loading"
        class="button is-danger">
         <span class="icon">
          <icon name="remove" scale="1" class="el-icon-fa"></icon>
        </span>
        <span>Очистить</span>
      </button>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import * as types from 'glonass/shop/site/store/mutation-types'
  import { numeral } from 'glonass/core/global'
  import { order as api } from 'glonass/shop/site/api'
  import CartMixin from 'glonass/shop/site/mixins/Cart'
  import 'vue-awesome/icons/remove'
  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/minus'
  import 'vue-awesome/icons/check'

  /**
   * Список ценовых предложений с кнопкой добавления в корзину.
   */
  export default {
    name: 'offer-list',

    mixins: [CartMixin],

    watch: {
      loading () {
        this.loading ? this.$Progress.start() : this.$Progress.finish()
      }
    },

    props: {
      offers: {
        type: Array,
        required: true
      },

      initialCart: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        numeral,
        api,

        /**
         * Выбранные предложения.
         * [{offer, quantity}]
         */
        innerValue: this.getInitialValue()
      }
    },

    methods: {
      ...mapActions('shop', [
        'putToCart'
      ]),

      handlePutToCart () {
        let items = _.filter(this.innerValue, 'quantity')
        items = _.map(items, this.normalizeCartItem)

        this.putToCart(items)
      },

      handleReset () {
        if (!confirm('Очистить выбранные позиции?')) {
          return
        }

        this.innerValue = _.map(this.innerValue, (item) => ({...item, quantity: 0}))
      },

      handleIncrement (index, inc) {
        const quantity = this.innerValue[index].quantity + inc

        this._setQuantity(index, quantity)
      },

      getInitialValue () {
        return _.map(this.offers, (offer) => ({offer, quantity: 0}))
      },

      _setQuantity (index, quantity) {
        quantity = parseInt(quantity, 10)

        if (isNaN(quantity) || quantity < 0) {
          quantity = 0
        }

        this.innerValue[index].quantity = quantity
        this.$emit('input', this.innerValue)
      }
    },

    computed: {
      ...mapState('shop', {
        loading: state => !!state.loading[types.PUT_TO_CART],
        success: state => state.success[types.PUT_TO_CART],
        errors: state => state.errors[types.PUT_TO_CART]
      }),

      selectedCount () {
        return _.sum(_.map(this.innerValue, (item) => item.quantity))
      },

      selectedPrice () {
        if (this.totalCount === 0) {
          return 0
        }

        return _.sum(_.map(this.innerValue, (item) => item.quantity * item.offer.price))
      }
    }
  }
</script>

<style scoped lang="scss">
  .gl-alert_padding {
    margin-bottom: 1.5rem;
  }

  .gl-increment-block {
    width: 140px;
  }

  .buttons .button {
    margin-bottom: .5rem;
  }
</style>



// WEBPACK FOOTER //
// Widget.vue?58890ce2